module.exports = __webpack_public_path__ + "static/chalkboard-7a014d756959521a00b6a9d721718cf3.jpg";